export default __webpack_public_path__ + "static/media/10.b55c18f1.png";